import React from 'react'
import GenericReport from '../GenericReport'

const WaterWashListPage: React.FC = () => {
  return <GenericReport reportId={15} />
}

export default WaterWashListPage
